import React, { useState, useEffect, useContext } from 'react';
import './ProductDisplay.css';
import star_icon from "../Assets/star_icon.png";
import { ShopContext } from '../../Context/ShopContext';
import { useNavigate } from 'react-router-dom';

const ProductDisplay = (props) => {
    const { product } = props;
    const { addToCart,all_product } = useContext(ShopContext);
    const navigate = useNavigate();

    const isSoldOut = product.soldOut || 
        (product.fileType === 'physical' && product.quantity === 0);

    // ✅ Find all products with the same name (color variants)
    const colorVariants = all_product.filter(
        (p) => p.name === product.name && p.color
    );
 
    // Only show dropdown if there are multiple color variants
    const hasColorVariants = colorVariants.length > 1;
    // Initialize the main image with the first image from the product
    const [mainImage, setMainImage] = useState(product.image_urls[0]);

    useEffect(() => {
        setMainImage(product.image_urls[0]);
    }, [product]);

    // Function to swap images
    const handleImageClick = (clickedImage) => {
        setMainImage(clickedImage);
    };

    // ✅ When a color is picked, navigate to that product's page
    const handleColorChange = (e) => {
        const selectedColor = e.target.value;
        const selectedProduct = colorVariants.find(p => p.color === selectedColor);
        if (selectedProduct) {
            navigate(`/product/${selectedProduct.id}`);
        }
    };

    return (
        <div className='productdisplay'>
            <div className='productdisplay-left'>
                <div className='productdisplay-img-list'>
                    {product.image_urls.slice(0, 4).map((img, index) => (
                        <img 
                            key={index} 
                            src={img} 
                            alt="" 
                            onClick={() => handleImageClick(img)} 
                            className="thumbnail-img"
                        />
                    ))}
                </div>
                <div className='productdisplay-img'>
                    <img className='productdisplay-main-img' src={mainImage} alt="" />
                </div>
            </div>
            <div className='productdisplay-right'>
                <h1 id='itemname'>{product.name}</h1>
                <div className='productdisplay-right-stars'>
                    {[...Array(5)].map((_, index) => (
                        <img key={index} src={star_icon} alt="" />
                    ))}
                    <p>(0)</p>
                </div>
                <div className='productdisplay-right-prices'>
                    <div className='productdisplay-right-price-old'></div>
                    <div className='productdisplay-right-price-new'>${product.new_price}</div>
                </div>
                {hasColorVariants && (
                    <div className="productdisplay-right-colors">
                        <h1>Color</h1>
                        <select
                            className="color-dropdown"
                            value={product.color || ''}
                            onChange={handleColorChange}
                        >
                            {colorVariants.map((variant) => (
                                <option
                                    key={variant.id}
                                    value={variant.color}
                                    disabled={variant.soldOut}
                                >
                                    {variant.color}{variant.soldOut ? ' — Sold Out' : ''}
                                </option>
                            ))}
                        </select>
                    </div>
                )}
 
                {/* Show single color as plain text if no variants */}
                {!hasColorVariants && product.color && (
                    <div className="productdisplay-right-colors">
                        <h1>Color</h1>
                        <p>{product.color}</p>
                    </div>
                )}
                <div className="productdisplay-right-size">
                    <h1>Size</h1>
                    <div className="productdisplay-right-sizes">
                        <h1>{product.size}</h1>
                    </div>
                </div>
                <button
                    onClick={() => !isSoldOut && addToCart(product.id)}
                    disabled={isSoldOut}
                    className={isSoldOut ? 'btn-soldout' : ''}
                >
                    <span>{isSoldOut ? 'SOLD OUT' : 'ADD TO CART'}</span>
                </button>
                <p className="productdisplay-right-category"><span>Category :</span> {product.category}</p>
                <p className="productdisplay-right-category"><span>Tags :</span> Handmade, Crochet</p>
            </div>
        </div>
    );
};

export default ProductDisplay;